(function () {
    let modal;

    let listenForShowRecipeUsageRequestFormButtonClick = function () {
        $("body").on("click", "#show-request-usage-form-btn", function (e) {
            e.preventDefault();
            showRecipeUsageRequestModal();
            return false;
        });
    };

    let listenForSubmitRecipeUsageRequestFormButtonClick = function() {
        $("#store-request-usage-form").submit(function (e) {
            e.preventDefault();
            storeRecipeUsageRequest();
        });
    }

    let storeRecipeUsageRequest = function () {
        const formLoader = modal.find('#submit-form-loader');
        const formButton = modal.find('#submit-form-btn');
        const errorEl = modal.find('#error');
        const _token = modal.find('input[name$="_token"]').val();
        const email = modal.find('input[name$="email"]').val();
        const comments = modal.find('textarea[name$="comments"]').val();

        $.ajax({
            method: "POST",
            url: viewModel.recipeUsageRequestURL,
            cache: false,
            data: {...viewModel, _token: _token, email: email, comments: comments},
            beforeSend: function () {
                errorEl.html('');
                modal.modal();
                formLoader.removeClass('display-none');
                formButton.attr('disabled', true);
            },
            success: function (response) {
                console.log(response);
                formLoader.addClass('display-none');
                formButton.attr('disabled', false);
                modal.find('#store-request-usage-form').addClass("d-none");
                modal.find('#success').html(response.message);
            },
            error: function (error) {
                formLoader.addClass('display-none');
                formButton.attr('disabled', false);
                errorEl.html(error.responseJSON.message);
                console.error(error);
            }
        });
    };

    let showRecipeUsageRequestModal = function () {
        modal.modal();
        modal.find('.loader').addClass('display-none');
    };

    let init = function () {
        modal = $('#recipe-usage-request-modal');
        listenForShowRecipeUsageRequestFormButtonClick();
        listenForSubmitRecipeUsageRequestFormButtonClick();
    };

    $(document).ready(function() {
        init();
    });

})();
